import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpUtilsService } from 'app/core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from 'app/core/_base/crud';
import { DatPhongHopModel } from '../dat-phong-hop-model/dat-phong-hop.model';

const API_ROOT_URL = environment.ApiRoot + '/datphong';

@Injectable()
export class HanhChanhService {	
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }
	getDatPhong(start, end, IdPhong, status): any{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/DatPhongHop_List?start=${start}&end=${end}&IdPhong=${IdPhong}&status=${status}`, { 
			headers: httpHeaders
		});	
	}	
	getPhongHop(): any{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + `/phonghop/PhongHop_List?more=true&sortOrder=asc&sortField=ViTri`, { 
			headers: httpHeaders
		});	
	}	
	getDatPhongHopById(Id_DP): any{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/DatPhongHop_Detail?IdDp=${Id_DP}`, { 
			headers: httpHeaders
		});	
	}
	createDatPhongHop(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DatPhongHopModel>(API_ROOT_URL+'/DatPhongHop_Insert', item, { headers: httpHeaders });
	}
	updateDatPhongHop(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DatPhongHopModel>(API_ROOT_URL+'/DatPhongHop_Update', item, { headers: httpHeaders });
	}
	checkExistBooking(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<DatPhongHopModel>(API_ROOT_URL+'/DatPhongHop_CheckExist', item, { headers: httpHeaders });
	}
}
